import { MessageBox, Message } from 'element-ui'
import Config from '@/constant/index'
import i18n from '@/i18n'

// 退出登录
export const toLoginPage = () => {
  // 退出之前，如果有redirect-url，则存起来
  const query = window.vueInstance.$route.query
  const key = Config.REDIRECT_URL
  if(query && query[key]) {
    sessionStorage.setItem(key, query[key])
  }

  let cti = window.top.cti
  if (cti && cti.Agent) {
    cti.Agent.logout()
  }
  window.location.href = window.location.origin + '/api/v3/logout'
}

// 统一的token失效提示框
export const showConfimLogoutBox = () => {
  MessageBox.confirm(i18n.t('home.logoutMessage'), i18n.t('home.confirmLogout'), {
    confirmButtonText: i18n.t('home.confirm'),
    cancelButtonText: i18n.t('home.cancel'),
    type: 'warning'
  }).then(() => {
    toLoginPage()
  }).catch((e) => {
    console.log(e)
    Message({
      message: i18n.t('home.cancelled'),
      duration: 1000
    })
  })
}

// 过滤对象中的值为空的属性
export const filterEmpty = (data, allowEmptyKeys) => {
  if (data) {
    if (data instanceof Array) {
      return data
    }
    const rst = {}
    Object.keys(data).forEach(key => {
      const value = data[key]
      if (allowEmptyKeys && allowEmptyKeys.includes(key)) {
        rst[key] = value
      } else {
        (value || value === 0 || typeof value === 'boolean') && (rst[key] = value)
      }
    })
    return rst
  }
}

export const recursionFind = (arr, val) => {
  let res = null;
  function deepFind(findArr, value) {
    findArr.forEach(item => {
      if (item.tag == value) {
        res = item;
      } else if (item.children && Array.isArray(item.children) && item.children.length > 0) {
        deepFind(item.children, value)
      }
    })
  }
  deepFind(arr, val);
  return res;
}

export const recursionSetString = (arr, key) => {
  function deepFind(findArr, key) {
    findArr.forEach(item => {
      item[key] !== undefined && item[key] == String(item[key]);
      if (item.children && Array.isArray(item.children) && item.children.length > 0) {
        deepFind(item.children, key)
      }
    })
  }
  deepFind(arr, key);
  return arr;
}

// 打开新tab
export const addTab = (title, url, icon, otherParams = {}) => {
  let add_tab_obj = {
    type: "4",
    key: title,
    title,
    name: title,
    url: url,
    icon
  };
  add_tab_obj = { ...add_tab_obj, ...otherParams }
  window.postMessage(add_tab_obj, "*");
};



// WEBPACK FOOTER //
// ./src/assets/js/utils.js